// For Firebase JS SDK v7.20.0 and later, measurementId is optional

import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";

const firebaseConfig = {
    apiKey: "AIzaSyD9YP_oJdY1xvIvcVgjakwTPNJHypYmyoA",
    authDomain: "linkedin-clone-abaf7.firebaseapp.com",
    projectId: "linkedin-clone-abaf7",
    storageBucket: "linkedin-clone-abaf7.appspot.com",
    messagingSenderId: "316645284163",
    appId: "1:316645284163:web:d23152bbc4f461477f37f6",
    measurementId: "G-SG9KEJF4F0"
  };

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();
const storage = firebase.storage();

export {auth, provider, storage};
export default db;